<template>
    <div>
        <Header></Header>
        <div class="user">
            <div class="user_container">
                <div class="steps">
                    <el-steps :active="active" align-center >
                        <el-step title="验证信息"></el-step>
                        <el-step title="修改密码"></el-step>
                        <el-step title="修改完成"></el-step>
                    </el-steps>
                </div>
                <!-- 第一步 -->
                <div class="form" v-if="active === 0">
                    <el-form :model="ruleFormMessage" status-icon :rules="messageRules" ref="ruleFormMessage" label-width="100px" class="demo-ruleForm">
                        <el-form-item prop="phone">
                            <el-input v-if="!isToken" v-model="ruleFormMessage.phone" placeholder="手机号">
                            </el-input>
                            <span v-else style="color: #858585;">验证码将发送到手机{{ ruleFormMessage.phone }},请注意查收</span>
                        </el-form-item>
                        <el-form-item prop="code">
                            <el-input v-model="ruleFormMessage.code" auto-complete="off" placeholder="验证码">
                                <i slot="suffix">
                                    <el-button @click="getCode()" class="codeBtn" :disabled="isSending || countdown > 0">
                                        {{ isSending ? '发送中...' : countdown > 0 ? `${countdown}秒后重试` : "获取验证码" }}
                                    </el-button>
                                </i>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <div class="button">
                                <el-button v-if="!isToken" @click="MessageToLogin" class="login">下一步</el-button>
                                <el-button v-else @click="changePwd">下一步</el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                    <!-- <el-button @click="active=1">下一页</el-button> -->
                </div>
                <!-- 第二 -->
                <div class="form" v-else-if="active === 1">
                    <el-form :model="ruleFormPassword" status-icon :rules="passwordRules" ref="ruleFormPassword" label-width="100px" class="demo-ruleForm">
                        <el-form-item prop="new">
                            <el-input type="password" v-model="ruleFormPassword.new" placeholder="请输入8-16位字母与数字的组合">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="new2">
                            <el-input type="password" v-model="ruleFormPassword.new2" auto-complete="off" placeholder="请再次输入">
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <div class="button">
                                <el-button v-if="!isToken" @click="updatePassword" class="login">确&nbsp;&nbsp;认</el-button>
                                <el-button v-else @click="updatePassword" class="login">确&nbsp;&nbsp;认</el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 第三步 -->
                <div class="form" v-else-if="active === 2">
                    <div class="success">
                        <div class="success-icon">
                            <img src="../../assets/image/资源 13.png">
                            <span style="font-size: 1rem; color: #999999">修改成功</span>
                        </div>
                        <div class="success-button" @click="returnLogin">
                            <span >返回首页</span>
                        </div>
                    </div>
                    <!-- <el-button @click="active=1">上一页</el-button> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "../../components/header/index.vue"
import { getVerifyCode, verifyCodeLogin, changeUserPassword, getCodeLogin, getUserPhone, sendVerifyCode, verifyPhone, changePasswordByPhone } from "../../util/index"
import { md5 } from 'js-md5'
import { mapState } from 'vuex'
export default {
    data() {
        var checkNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号不能为空'));
            }
            setTimeout(() => {
                var myReg=/^[1][3,4,5,7,8][0-9]{9}$/;
                if (!myReg.test(value) ) {
                    callback(new Error('请输入正确的手机号码'));
                } else {
                    callback();
                }
            }, 1000);
        };
        var checkCode = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('验证码不能为空'));
            }
        };
        var checkNew = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入登录密码'));
            }
            setTimeout(() => {
                var myReg=/^(?=.*[a-z])(?=.*\d)[^]{8,16}$/;
                if (!myReg.test(value) ) {
                    callback(new Error('密码必须包含数字,字母,且不少于8位'));
                } else {
                    callback();
                }
            }, 1000);
        };
        return {
            active:0,
            isToken: false,
            isSending: false,  // 是否正在发送验证码
            countdown: 0, // 倒计时
            userId:'',
            ruleFormMessage: { // 短信的表单
                phone: '',
                code: '',
            },
            ruleFormPassword: { // 密码的表单
                new:'',
                new2:'',
            },
            passwordRules: { // 密码的验证规则
                new: [
                    { validator: checkNew, trigger: 'blur' }
                ],
                new2: [
                    { validator: checkNew, trigger: 'blur' }
                ]
            },
            messageRules: {
                phone: [
                    { validator: checkNum, trigger: 'blur' }
                ],
                code: [
                    { validator: checkCode, trigger: 'blur' }
                ]
            },
        };
    },
    computed:{
        ...mapState(['userInformation'])
    },
    methods:{
        changePwd(){
            let obj = {
                code: this.ruleFormMessage.code
            }
            let token = window.localStorage.getItem('userToken')
            verifyPhone(obj, token).then(res=>{
                if(res.code==200){
                    this.$message.success('验证成功');
                    // window.localStorage.setItem('userToken',res.data.accessToken);
                    // window.localStorage.setItem('userName',this.ruleFormMessage.phone);
                    this.$store.commit('updateUserState')
                    this.active = 1
                }else{
                    this.$message.error(res.message);
                }
            })
        },
        MessageToLogin(){
            let formData = {
                phone: this.ruleFormMessage.phone,
                code: this.ruleFormMessage.code,
            }
            verifyCodeLogin(formData).then(res=>{
                if(res.code==200){
                    this.$message.success('登录成功');
                    window.localStorage.setItem('userToken',res.data.accessToken);
                    // window.localStorage.setItem('userName',this.ruleFormMessage.phone);
                    this.$store.commit('updateUserState')
                    this.active = 1
                    // this.userId = res.data.userId
                    // this.$router.push('/')
                }else if(res.code=='2'){
                    console.log('对，我这里出问题了');
                    this.$message.error(res.message);
                    this.isSending = false;
                }else {
                    this.$message.error(res.message);
                }
            })
        },
        getCode(){
            if(this.countdown > 0 || this.isSending) {
                return
            }
            this.isSending = true;
            this.startCountdown();
            if(this.isToken){
                // 个人中心来的
                let token = window.localStorage.getItem('userToken');
                sendVerifyCode(token).then((res)=>{
                    if(res.code === 200){
                        this.$message.success('验证码已发送，注意查收');
                        this.isSending = false;
                    }else{
                        this.$message.error(res.message)
                    }
                })
            }else{
                let phoneObj = {
                    phone: this.ruleFormMessage.phone
                }
                getVerifyCode(phoneObj).then((res)=>{
                    if(res.code === 200){
                        this.$message.success('验证码已发送，注意查收');
                        this.isSending = false;
                    }else{
                        this.$message.error(res.message)
                    }
                })
            }
        },
        // 倒计时计数
        startCountdown(){
            this.countdown = 60;
            const timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(timer);
                }
            }, 1000);
        },
        // 返回登录
        returnLogin(){
            this.$router.push('/')
            window.localStorage.removeItem('userToken')
            window.localStorage.removeItem('userName')
        },
        // 修改密码
        updatePassword(){
            if(this.isToken){
                // 个人中心来的
                let obj = {
                    password : md5(this.ruleFormPassword.new),
                    code : this.ruleFormMessage.code,
                }
                let token  = window.localStorage.getItem("userToken")
                changePasswordByPhone(obj, token).then(res=>{
                    if(res.code === 200){
                        this.active = 2
                    }else{
                        this.$message.error(res.message)
                    }
                })
                
            }else{
                let passwordObj = {
                    password : md5(this.ruleFormPassword.new),
                    code : this.ruleFormMessage.code,
                }
                let token  = window.localStorage.getItem("userToken")
                changeUserPassword(passwordObj, token).then((res)=>{
                    if(res.code === 200){
                        this.active = 2
                    }else{
                        this.$message.error(res.message)
                    }
                })
            }
        }
    },
    components:{
        Header
    },
    mounted(){
        // 个人中心过来的
        const userToken = window.localStorage.getItem("userToken")
        if(userToken){
            this.isToken = true
            getUserPhone(userToken).then(res=>{
                if(res.code === 200){
                    this.ruleFormMessage.phone = res.data
                }else{
                    this.$message.error(res.message)
                }
            })
        }

        // if(!userToken){
        //     this.$message.error("请先登录")
        //     this.$router.push("/login")
        // }
    }
}
</script>

<style scoped lang="less">
::v-deep .el-input__inner{
    border-radius: 10px;
    width: 25rem;
}
::v-deep .el-form-item__content{
    margin-left: 0 !important;
}
::v-deep .el-step__head.is-finish{
    color: #d7d7d7;
    border-color: #d7d7d7;
}
::v-deep .el-step__title{
    font-size: 0.97rem;
    line-height: 3.75rem;
}
::v-deep .el-step__title.is-finish {
    color: #d7d7d7;
}
::v-deep .el-step__head.is-process{
    color: #54ceec;
    border-color: #54ceec;
}
::v-deep .el-step__title.is-process {
    color: #54ceec;
}
.user{
    background-color: #cad3d4;
    min-width: 1350px;
    width: 100vw;
    padding-top: 3rem;
    height: calc(100vh - 51px);
    .user_container {
        width: 60%;
        padding: 4rem 3rem 20rem;
        border-radius: 10px;
        margin: 0 auto;
        background-color: rgb(255, 255, 255);
        display: flex;
        flex-direction: column;
        justify-content: center;
        // .steps{
        //     // background-color: #cad3d4;
            
        // }
        .form{
            // background-color: #54ceec;
            display: flex;
            flex-direction: column;
            // justify-content: center;
            align-items: center;
            padding-top: 3rem;
            .codeBtn{
                background-color: #54ceec;
                border-radius: 20px;
                padding: 8px 9px 10px 10px;
            }
            .codeBtn:hover{
                color: #E3E8EF;
            }
            .button{
                // background-color: red;
                display: flex;
                justify-content: center;
                ::v-deep .el-button{
                    width: 10rem;
                    border-radius: 20px;
                    margin-top: 1rem;
                    color: #fff;
                    background-color: #54ceec;
                }
            }
            .success{
                // background-color: #54ceec;
                .success-icon{
                    padding: 3rem 5rem 6rem;
                    display: flex;
                    align-items: center;
                    span{
                        margin-left: 0.5rem;
                        color: #7d7d7d;
                        font-size: 1.2rem;
                        font-weight: 600;
                    }
                }
                .success-button{
                    // 添加下划线
                    font-size: 0.8rem;
                    cursor: pointer;
                    text-decoration: underline;
                    letter-spacing: 1px;
                    display: flex;
                    justify-content: center;
                    color: #54ceec;
                }
            }
        }
    }
}


</style>